<template>
  <Dropdown
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    :options="opciones"
    optionLabel="name"
    optionValue="id"
    :loading="cargando"
    :placeholder="placeholder"
    :filter="filter"
    class="w-full"
    :disabled="disabled"
  />
</template>

<script>
export default {
  name: 'DropdownData',
  props: {
    // El ID seleccionado (v-model)
    modelValue: {
      type: [String, Number],
      default: null
    },
    // La función del servicio que retorna la promesa con los datos
    serviceFunction: {
      type: Function,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Seleccione una opción...'
    },
    filter: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      opciones: [],
      cargando: false
    }
  },
  mounted() {
    this.cargarDatos();
  },
  methods: {
    async cargarDatos() {
      this.cargando = true;
      try {
        const response = await this.serviceFunction();
        // Dependiendo de si la respuesta envuelve los datos en 'data' o no
        this.opciones = response.data ? response.data : response;
      } catch (error) {
        console.error("Error al cargar opciones del Dropdown:", error);
      } finally {
        this.cargando = false;
      }
    }
  }
}
</script>
